import { serverTimestamp, updateDoc, type DocumentData, type UpdateData } from 'firebase/firestore'
import type { _FirebaseDocument } from '@/models/Models'
import { logger } from '@/utils/logger'

/**
 * A partial update of a model's own document, stamped `updated_at`. Models stay
 * pure (front-data skill): the write lives here, in the data layer, and stores
 * call it.
 */
export async function updateModelDoc(model: _FirebaseDocument, data: UpdateData<DocumentData>): Promise<void> {
  const ref = model.toDocumentReference()
  if (!ref) {
    logger.error('DocumentReference is null')
    return
  }
  await updateDoc(ref, { ...data, updated_at: serverTimestamp() })
}
